<template>
  <div class="heading">
    {{ text.preHighlight }}
    <span v-if="text.highlight" class="highlight">{{ text.highlight }}</span>
    {{ text.postHighlight }}
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
<style lang="scss" scoped>
  .heading {
    margin-bottom: 10px;
    font-size: 24px;
    line-height: 30px;
    font-weight: bold;
  }

  .highlight {
    // border-bottom: 3px solid $nos-op3-red;
  }
</style>



// WEBPACK FOOTER //
// src/components/SectionHeading.vue